export const sceneActions = function sceneActions() {
  return {
    update: async (el, s, ctx) => {
      const { demoFrameElement } = el.data
      if (!demoFrameElement) return

      if (s.variant) s.variant = s.variant

      const demoComponent = el.call('deepClone', s.value)

      const frameProps = {
        ...el.scope.frameProps,
        ...s,
        style: {
          transform: `scale(${parseFloat(s.zoomLevel, 2)})`
        }
      }

      if (s.base) frameProps.fontSize = s.base + 'px'
      if (s.ratio) frameProps['--spacing-ratio'] = s.ratio

      demoFrameElement.update(frameProps)
      demoFrameElement.state.set(s.state)
      demoFrameElement.demoComponent.update(demoComponent)
    },
    recreate: async (el, s, ctx) => {
      if (el.data.demoFrameElement) {
        el.data.demoFrameElement.node.remove()
        el.data.demoFrameElement.remove()
        delete el.data.demoFrameElement
      }
      await el.onRenderScene?.(el, s, ctx)
    }
  }
}
